module.exports = __webpack_public_path__ + "static/media/chair1left.ed477008.png";